import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";
import { useTranslation } from "react-i18next";
import { IoIosCheckmarkCircle } from "react-icons/io";

type ValidateAllProductsModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  productsCount: number;
};

const ValidateAllProductsModal = ({
  isOpen,
  onCancel,
  onConfirm,
  productsCount,
}: ValidateAllProductsModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      backdrop="opaque"
      placement="top-center"
      size="md"
      classNames={{
        backdrop:
          "bg-gradient-to-t from-vistadark/80 to-vistadark/60 backdrop-opacity-20",
      }}
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-2">
          <IoIosCheckmarkCircle className="text-vistagreen text-xl" />
          <span className="text-sm">{t("validate_all_products_title")}</span>
        </ModalHeader>
        <ModalBody>
          <p className="text-sm">
            {t("validate_all_products_message", { count: productsCount })}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="default" size="md" variant="flat" onPress={onCancel}>
            {t("cancel")}
          </Button>
          <Button color="primary" size="md" onPress={onConfirm}>
            {t("confirm")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ValidateAllProductsModal;
